import { Route, Routes } from 'react-router-dom'

import type { CampaignModel } from '@models/types'

import Details from './screens/Details'

type CampaignQuoteEditRoutesProps = {
  campaign: CampaignModel,
}

const CampaignQuoteEditRoutes = (props: CampaignQuoteEditRoutesProps) => {
  const { campaign } = props

  return (
    <Routes>
      <Route index element={<Details campaign={campaign} />} />
    </Routes>
  )
}

export default CampaignQuoteEditRoutes
